(function () {
  'use strict';

  function setStatus(message) {
    document.querySelectorAll('#NetworkKitCookieSettingsStatus').forEach(function (status) {
      status.textContent = message;
    });
  }

  function attach() {
    document.querySelectorAll('[data-networkkit-cookie-settings]').forEach(function (button) {
      if (button.dataset.networkkitCookieSettingsBound === 'true') return;
      button.dataset.networkkitCookieSettingsBound = 'true';
      button.addEventListener('click', function () {
        if (window.privacyBanner && typeof window.privacyBanner.showPreferences === 'function') {
          setStatus('Cookie preferences opened.');
          Promise.resolve(window.privacyBanner.showPreferences()).catch(function () {
            setStatus('Cookie preferences could not be opened. Please try again.');
          });
        } else {
          setStatus('Cookie preferences are currently unavailable.');
        }
      });
    });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', attach, { once: true });
  else attach();
})();
